<template>
    <v-row v-if="selectedQuest && selectedQuest.id">
        <v-col cols="10" offset="1" v-if="selectedQuest.total !== null">
        <h2>
            <span style="font-weight: 100;">COLABORADOR </span>
            <span>{{ classificar_avaliacao(selectedQuest.total).toUpperCase() }}</span>
            <span>: {{ selectedQuest.total }}</span>
        </h2>
        </v-col>
        <v-col cols="10" offset="1">
        <v-card class="my-1">
            <v-card-title style="justify-content:center">
              <span v-html="selectedQuest.questionario_titulo"></span>
            </v-card-title>
            <v-card-text>
            <div class="my-4">
              <span v-html="selectedQuest.questionario_subtitulo"></span>
            </div>
            <div v-for="(formquest, campo_id) in selectedQuest.respostas" :key="campo_id">
                <v-divider class="my-3"></v-divider>
                <v-alert color="#2A3B4D" v-if="formquest.competencia">
                  <b>{{ campo_id + 1 }} - {{ formquest.competencia.nome }}</b> <br>
                  {{ formquest.competencia.descricao }}
                </v-alert>
                <h3 class="mb-1">
                  <span v-html="formquest.titulo"></span>
                </h3>
                <div v-if="formquest.tipo === TEXT">
                  <div v-for="(campo, ind) in formquest.options" :key="ind">
                      <div class="ma-3">
                      "<span class="font-italic" v-html="formquest.value"></span>"
                      </div>
                  </div>
                </div>
                <div v-if="formquest.tipo === SINGLE">
                  <div v-for="(campo, ind) in formquest.options" :key="ind">
                      <v-radio-group v-model="formquest.value" hide-details disabled>
                      <v-radio :label="campo.label" :value="campo.peso"></v-radio>
                      </v-radio-group>
                  </div>
                </div>
                <div v-if="(formquest.subquestions || []).length">
                <v-divider class="my-2"></v-divider>
                <div v-for="(subquest, index) in formquest.subquestions" :key="index">
                    <div class="ma-3">
                      <div class="font-weight-bold" v-html="subquest.titulo"></div>
                      "<span class="font-italic" v-html="subquest.resposta"></span>"
                    </div>
                </div>
                </div>
            </div>
            </v-card-text>
        </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
  props: {
    selectedQuest: {
      type: Object,
      required: true,
    },
    classificar_avaliacao: {
      type: Function,
      required: true,
    },
  },
  data: (()=>({
    SINGLE: 'single',
    TEXT: 'text',
  }))
};
</script>
  
